type BffFacility = {
	location?: {
		distance?: number | null;
		longitude?: number | null;
		latitude?: number | null;
		timeZone?: string | null;
		landmarks?: string | null;
		neighboringAreas?: string[] | string | null;
	} | null;
	address?: {
		address1?: string | null;
		address2?: string | null;
		city?: string | null;
		zipCode?: string | null;
		stateCode?: string | null;
	} | null;
	brand?: string | null;
	code?: string | null;
	comingSoon?: boolean | null;
	name?: string | null;
	scheduleAppointmentURL?: string | null;
	phoneNumber?: string | null;
	status?: string | null;
	workingHours?: unknown;
	openDate?: string | null;
	attributes?: unknown[] | null;
	email?: string | null;
} | null;

export const mapFacilities = (facilities: any[] | null | undefined) => {
	return (
		facilities?.map((facility: any) => ({
			distanceInMiles: facility?.location?.distance,
			facility: {
				address: {
					address1: facility?.address?.address1 ?? null,
					address2: facility?.address?.address2 ?? null,
					city: facility?.address?.city ?? null,
					zipCode: facility?.address?.zipCode ?? null,
					stateCode: facility?.address?.stateCode ?? null,
				},
				brand: facility?.brand,
				code: facility?.code ?? '',
				comingSoon: facility?.comingSoon ?? false,
				location: {
					address1: facility?.address?.address1 ?? null,
					address2: facility?.address?.address2 ?? null,
					city: facility?.address?.city ?? null,
					zipCode: facility?.address?.zipCode ?? null,
					stateCode: facility?.address?.stateCode ?? null,
					longitude: facility?.location?.longitude ?? 0,
					latitude: facility?.location?.latitude ?? 0,
					timeZone: facility?.location?.timeZone,
					ianaTimeZone: facility?.location?.timeZone ?? '',
					landmarks: facility?.location?.landmarks,
					neighbouringAreas: facility?.location?.neighboringAreas,
					dst: false,
				},
				name: facility?.name ?? '',
				officeWorkingHours: [],
				scheduling: {
					schedulingUrl: facility?.scheduleAppointmentURL,
				},
				technicalInfrastructure: { phoneNumber: facility?.phoneNumber },
				status: facility?.status,
				workingHours: facility?.workingHours,
				openDate: facility?.openDate ?? null,
				attributes: facility?.attributes ?? [],
				email: facility?.email ?? null,
			},
		})) ?? []
	);
};
